// Generated by CoffeeScript 1.11.1

/**
Finds out if the browser supports placeholders.

@method placeholderSupported
@return {Boolean} whether or not plachoders are supported
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/placeholder_supported',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.placeholderSupported = factory();
  }
})(this, function() {
  var placeholderSupported;
  return placeholderSupported = function() {
    return 'placeholder' in document.createElement('input');
  };
});

